import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "@/i18n/I18nContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import MFASetup from "@/pages/MFASetup";
import MFAVerify from "@/pages/MFAVerify";
import Overview from "@/pages/dashboard/Overview";
import Projects from "@/pages/dashboard/Projects";
import Licenses from "@/pages/dashboard/Licenses";
import Tickets from "@/pages/dashboard/Tickets";
import Documents from "@/pages/dashboard/Documents";
import Notifications from "@/pages/dashboard/Notifications";
import SygnalShield from "@/pages/SygnalShield";
import SafeLink from "@/pages/SafeLink";
import SygnalVault from "@/pages/dashboard/SygnalVault";
import InquiriesInbox from "@/pages/dashboard/InquiriesInbox";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="App">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/sygnal-shield" element={<SygnalShield />} />
              <Route path="/safelink" element={<SafeLink />} />
              <Route path="/login" element={<Login />} />
              <Route path="/mfa/setup" element={<MFASetup />} />
              <Route path="/mfa/verify" element={<MFAVerify />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Overview />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/projects"
                element={
                  <ProtectedRoute>
                    <Projects />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/licenses"
                element={
                  <ProtectedRoute>
                    <Licenses />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/tickets"
                element={
                  <ProtectedRoute>
                    <Tickets />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/documents"
                element={
                  <ProtectedRoute>
                    <Documents />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/notifications"
                element={
                  <ProtectedRoute>
                    <Notifications />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/sygnal-vault"
                element={
                  <ProtectedRoute>
                    <SygnalVault />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/inquiries"
                element={
                  <ProtectedRoute>
                    <InquiriesInbox />
                  </ProtectedRoute>
                }
              />
            </Routes>
            <Toaster theme="dark" />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
